import { useAccount } from './AccountContext';

export function ProfileAccount() {
  const account = useAccount()!;
  return (
    <>
      <div className="profile-account-detail">
        <span>Signed in as</span>
        <p>{account.label}</p>
      </div>
      <div className="profile-account-detail">
        <span id="profile-wallet-label">Privy EVM wallet</span>
        <div
          className="profile-wallet-field"
          aria-labelledby="profile-wallet-label"
        >
          {account.wallet || 'Sign in again to create your wallet.'}
        </div>
      </div>
      <button className="account-signout" onClick={account.logout}>
        Sign out
      </button>
    </>
  );
}
